import {Config, CognitoIdentityCredentials} from "aws-sdk";
import {
    CognitoUserPool,
    CognitoUserAttribute
} from "amazon-cognito-identity-js";
import * as AmazonCognitoIdentity from "amazon-cognito-identity-js";
import axios from "axios/index";



export const authService = {
    register,
    changePassword,
    ConfirmPassword,
    login,
    forgotPassword,
    getProfile

};


const appConfig   = {
    region: 'us-west-2',
    IdentityPoolId: 'us-west-2:f0cbab10-9f16-414c-ae61-db9e4573e433',
    UserPoolId: 'us-west-2_Emw8UaHFR',
    ClientId: '1m67jcoc8jgk5ilifnmtk11oqg',
};
const apIConfig   = {
    flatlayConnectGatewayAPI: 'https://8i9s27h4vl.execute-api.us-west-2.amazonaws.com/dev/',
};
Config.region = appConfig.region;


const userPool = new CognitoUserPool({
    UserPoolId: appConfig.UserPoolId,
    ClientId: appConfig.ClientId,
});

const toUsername=(email)=> {
    return email.replace('@', '-at-');
};
const createCognitoUser=(email)=>{
    return new AmazonCognitoIdentity.CognitoUser({
        Username: toUsername(email),
        Pool: userPool
    });
};


function register(email, password, onSuccess, onFailure){
    const attributeList = [
        new CognitoUserAttribute({
            Name: 'email',
            Value: email,
        })
    ];
    Config.credentials = new CognitoIdentityCredentials({
        IdentityPoolId: appConfig.IdentityPoolId,
        LoginId: email
    });
    userPool.signUp(toUsername(email), password, attributeList, null, (err, result) => {
        if (!err) {
            onSuccess(result)
        }else {
            onFailure(err);
        }

        console.log('user name is ' + result.user.getUsername());
        console.log('call result: ' + result);
    });

}
function login(email, password, onSuccess, onFailure) {
    const authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails({
        Username: toUsername(email),
        Password: password
    });

    const cognitoUser = createCognitoUser(email);

    cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: onSuccess,
        onFailure: onFailure
    });
}
function ConfirmPassword(user, onSuccess, onFailure){
    createCognitoUser(user.email).confirmPassword(user.verificationCode,user.newPassword,{
        onSuccess: onSuccess,
        onFailure: onFailure
    })
}
function forgotPassword(user,onSuccess, onFailure){
    createCognitoUser(user.email).forgotPassword({
        onSuccess: onSuccess,
        onFailure: onFailure
    })
}
function changePassword(email,OldPassword,NewPassword,onSuccess, onFailure){


    let authenticationData = {
        Username : toUsername(email),
        Password : OldPassword,
    };

    let poolData = {
        UserPoolId: appConfig.UserPoolId,
        ClientId: appConfig.ClientId
    };
    let userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

    let authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(authenticationData);
    let userData = {
        Username : toUsername(email),
        Pool :  userPool
    };
    let cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
    cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: function (result) {
            // var accessToken + ' + result.getAccessToken().getJwtToken());
            cognitoUser.changePassword(OldPassword,NewPassword,(err, result) => {

                if (!err) {
                    onSuccess(result);
                } else {
                    onFailure(err);
                }
            })
        },

        onFailure: function(err) {
            alert(err);
        }
    });


}

function getProfile(email) {
   return axios
        .get(`${apIConfig.flatlayConnectGatewayAPI}merchant?group=${'brand'}&email=${email}`)

}